import { useEffect, useState } from 'react';
import { useLoginFlow } from './useLoginFlow';

interface RateLimitBannerProps {
  untilMs: number;
}

export function RateLimitBanner({ untilMs }: RateLimitBannerProps) {
  const { dispatch } = useLoginFlow();
  const [remaining, setRemaining] = useState(() => Math.max(0, Math.ceil((untilMs - Date.now()) / 1000)));

  useEffect(() => {
    const tick = () => {
      const secs = Math.max(0, Math.ceil((untilMs - Date.now()) / 1000));
      setRemaining(secs);
      if (secs <= 0) {
        clearInterval(id);
        dispatch({ type: 'CLEAR_RATE_LIMIT' });
      }
    };

    const id = setInterval(tick, 500);
    tick();
    return () => clearInterval(id);
  }, [untilMs, dispatch]);

  if (remaining <= 0) return null;

  return (
    <div
      style={{
        background: 'var(--badge-pending-bg)',
        border: '1px solid var(--status-limited)',
        borderRadius: 'var(--radius-md)',
        padding: '10px 14px',
        fontSize: 'var(--text-sm)',
        color: 'var(--badge-pending-text)',
        lineHeight: 'var(--leading-normal)',
      }}
    >
      Too many attempts. Try again in{' '}
      <span style={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>{remaining}s</span>.
    </div>
  );
}
